(function() {
  'use strict';

  angular.module('mean.foreman').directive('dragMe', function () {
    return {
      restrict: 'A',
      link: function(scope, elem, attr, ctrl) {
        //elem.draggable();
      }
    };
  });

  angular.module('mean.foreman').directive('modalDialog', function(){
    return {
      restrict: 'AC',
      link: function($scope, element) {
          console.log('in the modalDialog draggable');
          var draggableStr = "draggableModal";
          var header = $(".modal-header", element);

          header.on('mousedown', (mouseDownEvent) => {
            var modalDialog = element;
            var offset = header.offset();

            modalDialog.addClass(draggableStr).parents().on('mousemove', (mouseMoveEvent) => {
                  $("." + draggableStr, modalDialog.parents()).offset({
                      top: mouseMoveEvent.pageY - (mouseDownEvent.pageY - offset.top),
                      left: mouseMoveEvent.pageX - (mouseDownEvent.pageX - offset.left)
                  });
              }).on('mouseup', () => {
                   modalDialog.removeClass(draggableStr);
              });
          });    
       }
    }  
  });

  angular.module('mean.foreman').directive('ngdialogContent', function(){
    return {
      restrict: 'AC',
      link: function($scope, element) {
          console.log('in the ngdialogContent draggable');
          var draggableStr = "draggable";
          var header = $(".ng-binding", element);

          header.on('mousedown', (mouseDownEvent) => {
            var modalDialog = element;
            var offset = header.offset();

            modalDialog.addClass(draggableStr).parents().on('mousemove', (mouseMoveEvent) => {
                  $("." + draggableStr, modalDialog.parents()).offset({
                      top: mouseMoveEvent.pageY - (mouseDownEvent.pageY - offset.top),
                      left: mouseMoveEvent.pageX - (mouseDownEvent.pageX - offset.left)
                  });
              }).on('mouseup', () => {
                   modalDialog.removeClass(draggableStr);
              });
          });    
       }
    }  
  });
})();



// WEBPACK FOOTER //
// ./packages/custom/foreman/public/directives/drag-me.js